import { connect } from 'react-redux';
import ActivityMetric from './ActivityMetric';
import {
  metricUserActivityShort,
  metricUserActivityDetailed
} from '../../../store/actions/metric';

const mapStateToProps = ({ metricReducer }) => ({ metricReducer });
const mapDispatchToProps = {
  metricUserActivityShort,
  metricUserActivityDetailed
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityMetric);
